import {ActionButtonEnum} from "./action.button.const";


export interface CommonModalBoxResponse<D, O = any> {
  actionType?: ModalBoxUtils;
  data?: D;
  other?: O;
  viewType?: number;
}

export interface ModalBoxUtils {
  title?: string;
  buttonTitle?: string;
  actionTypeEnum?: number;
  close?: string;
  cancel?: string;
}

export const ActionButtonConstant = {
  Cancel: 'Cancel',
  Success: 'Success',
  Failed: 'Failed',
  Close: 'Close',
  Child: {
    title: 'Add Child',
    buttonTitle: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Child
  },
  Add: {
    title: 'Create',
    buttonTitle: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Create
  },
  Edit: {
    title: 'Edit',
    buttonTitle: 'Update',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Update
  },
  Delete: {
    title: 'Delete',
    buttonTitle: 'Delete',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Delete
  },
  Clear: {
    title: 'Clear',
    buttonTitle: 'Clear',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Clear
  },
  Apply: {
    title: 'Apply',
    buttonTitle: 'Apply',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Apply
  },
  Upload: {
    title: 'Upload',
    buttonTitle: 'Apply',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Upload
  },
  FilterApply: {
    title: 'Apply',
    actionTypeEnum: ActionButtonEnum.FilterSubmit
  },
  FilterReset: {
    title: 'Clear',
    actionTypeEnum: ActionButtonEnum.FilterReset
  },
  FilterCancelOrClose: {
    title: 'Cancel',
    actionTypeEnum: ActionButtonEnum.FilterCancelOrClose
  },
  Manage: {
    title: 'Create',
    buttonTitle: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.Manage
  },
  MapURL: {
    title: 'Create',
    buttonTitle: 'Save',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.MapURL
  },
  UploadParcels: {
    title: 'Upload Parcels',
    buttonTitle: 'Upload',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.UploadParcels
  },
  CreateAdhocParcel: {
    title: 'Create Adhoc Parcel',
    buttonTitle: 'Create',
    close: 'Close',
    cancel: 'Cancel',
    actionTypeEnum: ActionButtonEnum.CreateAdHocValidParcel
  }
};
